import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InventoryModel } from "states/product/product.models";
import { getSystemConfig } from "states/system-setting/system-setting.api";
import { GlobalValueState } from "./global-value.models";

const isAutoPrintOrderOnline = "IsAutoPrintOrderOnline";
const getIsAutoPrintOrderOnlineLocalStorage = (): boolean => {
  const value = localStorage.getItem(isAutoPrintOrderOnline);
  return value === "true" ? true : false;
};

export const setIsAutoPrintOrderOnlineLocalStorage = (value: boolean) =>
  localStorage.setItem(isAutoPrintOrderOnline, value.toString());

const initialState = {
  isLoading: false,
  isLoadingApp: true,
  mceModal: {
    show: false,
  },
  productStockModal: {
    show: false,
    productStocks: [] as InventoryModel[],
  },
  notificationEmails: [] as string[],
  globalMessage: undefined,
  separateProductEachBranch: false,
  autoPrintOrderOnline: getIsAutoPrintOrderOnlineLocalStorage(),
} as GlobalValueState;

export const fetchSystemConfig = createAsyncThunk(
  "globalValue/fetchSystemConfig",
  async () => {
    try {
      const res = await getSystemConfig();
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const globalValueSlice = createSlice({
  name: "globalValue",
  initialState: initialState,
  reducers: {
    setLoading(
      state,
      action: {
        payload: boolean;
      }
    ) {
      state.isLoading = action.payload;
    },
    setLoadingApp(state, action: PayloadAction<boolean>) {
      state.isLoadingApp = action.payload;
    },
    setMceModal(
      state,
      action: PayloadAction<{
        show: boolean;
        value?: string;
        onChange?: (value?: string) => void;
      }>
    ) {
      state.mceModal = action.payload;
    },
    setProductStockModal(
      state,
      action: PayloadAction<{
        show: boolean;
        productStocks: InventoryModel[];
      }>
    ) {
      state.productStockModal = action.payload;
    },
    setGlobalMessage(state, action: PayloadAction<string | undefined>) {
      state.globalMessage = action.payload;
    },
    setIsAutoPrintOrderOnline(state, action: PayloadAction<boolean>) {
      setIsAutoPrintOrderOnlineLocalStorage(action.payload);
      state.autoPrintOrderOnline = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSystemConfig.fulfilled, (state, action) => {
      return {
        ...state,
        ianaTimeZone: action.payload.ianaTimeZone,
        hostUrl: action.payload.hostUrl,
        name: action.payload.name,
        notificationEmails: action.payload.notificationEmails,
        timeZone: action.payload.timeZone,
        separateProductEachBranch: action.payload.separateProductEachBranch,
      };
    });
  },
});

export const {
  setLoading,
  setLoadingApp,
  setMceModal,
  setProductStockModal,
  setGlobalMessage,
  setIsAutoPrintOrderOnline,
} = globalValueSlice.actions;
